import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  private platformId = inject<Object>(PLATFORM_ID);

  constructor() {}

  setPushNotification(company) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (company?.pushNotification?.type && company?.pushNotification?.id) {
      const script = document.createElement('script');
      const script2 = document.createElement('script');
      switch (company.pushNotification.type) {
        case 'ONESIGNAL':
          script.innerHTML =
            'window.OneSignalDeferred = window.OneSignalDeferred || [];\n' +
            'OneSignalDeferred.push(async function(OneSignal) {\n' +
            'await OneSignal.init({\n' +
            "appId: '" +
            company.pushNotification.id +
            "',\n" +
            'notifyButton: {\n' +
            'enable: true' +
            '},\n' +
            '});' +
            '});';

          script2.src = 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js';
          script2.async = true;
          document.head.appendChild(script2);
          script2.onload = () => {
            document.head.appendChild(script);
            script.onload = () => {};
          };
          break;
      }
    }
  }
}
